import { getClaims } from "../tokenHelper";

function useRequiredPermission(requiredPermission: string[]): boolean {
  const claims = getClaims();
  let userHasRequiredPermission = false;

  if (typeof claims?.permission === "string") {
    userHasRequiredPermission =
      requiredPermission?.indexOf(claims.permission) >= 0;
  } else {
    userHasRequiredPermission =
      claims?.permission?.some(
        (r: string) => requiredPermission?.indexOf(r) >= 0
      ) ?? false;
  }

  return userHasRequiredPermission;
}

export default useRequiredPermission;
